import { render, staticRenderFns } from "./Login_WeiXin.vue?vue&type=template&id=3ecbb6db&scoped=true&"
import script from "./Login_WeiXin.vue?vue&type=script&lang=js&"
export * from "./Login_WeiXin.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ecbb6db",
  null
  
)

export default component.exports